import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { RtUICoreOverlayModule } from './../../core/core.module';
import { BulkSelectComponent } from './bulk-select.component';

@NgModule({
  exports: [BulkSelectComponent],
  imports: [CommonModule, I18nModule, RtUICoreOverlayModule, BulkSelectComponent],
})
export class BulkSelectModule {}
export { BulkSelectComponent } from './bulk-select.component';
